import Web3 from 'web3';
import { getAccountBalance, getGasPrice } from './earthApiService';

const web3 = new Web3(process.env.REACT_APP_EARTH_API_URL);

export async function fetchAssets(address) {
  try {
    const balance = await getAccountBalance(address);
    
    // For now, we'll just return the native token balance
    // You may want to implement fetching other token balances in the future
    return [
      {
        symbol: 'HUMAN',
        balance: balance,
        name: 'Human',
        decimals: 18,
      }
    ];
  } catch (error) {
    console.error('Error fetching assets:', error);
    return [];
  }
}

export async function getCurrentGasPrice() {
  try {
    return await getGasPrice();
  } catch (error) {
    console.error('Error fetching gas price:', error);
    return null;
  }
}

export async function getLatestBlockNumber() {
  try {
    const blockNumber = await web3.eth.getBlockNumber();
    return blockNumber;
  } catch (error) {
    console.error('Error fetching latest block number:', error);
    throw error;
  }
}